module.exports = __webpack_public_path__ + "static/EnmTX_BosAlbus_L_A_cl-fdbc3c9ff4a26e1f85838ba1aee94563.gif";